import React from 'react';
import BrandPage from './BrandPage';

const FoxESSPage = () => <BrandPage brandSlug="fox-ess" />;

export default FoxESSPage;
